import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import atavar1 from "/public/images/1@2x.png";
import buriedSdk from "@/utils/zz-buried/index";
import { useWidth } from "@/utils/resize";
type Props = {};
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("home");
  const { width, display } = useWidth();
  return (
    <div className={styles["influence-box"]}>
      <div className="defeaultContainer">
        <div className={styles.itemBox}>
          <div className={`${styles.item} `}>
            <div className=" animate-box">
              <div className="ant">
                <h2 className={styles.title}>{t('For TikTok Influencers')}</h2>
                <h3 className={styles.p1}>{t('influencerTitle1')}</h3>
                <p
                  className={styles.p}
                >{t('influencerTip1')}</p>
                <h3
                  className={styles.p1}
                >{t('influencerTitle2')}</h3>
                <p
                  className={styles.p}
                >{t('influencerTip2')}</p>
                <h3 className={styles.p1}>{t('influencerTitle3')}</h3>
                <p
                  className={styles.p}
                >{t('influencerTip3')}</p>
                <a
                  href={width> 1024?`${process.env.portalUrl}/influencer/sales`:`${process.env.mobileUrl}/rank?type=Influencers&rankType=breakout`}
                  className={styles.get}
                  onClick={() => {
                    buriedSdk.buried({
                      event: `Shoplus官网_${width > 1024 ? "Web" : "H5"}`,
                      scene: `For Influencers_Get Started`,
                      URL: process.env.publicApiDomain,
                    });
                  }}
                >
                  {t('Get Started')}
                </a>
                <a
                  href={`${width> 1024?process.env.portalUrl: process.env.mobileUrl}/checkout`}
                  className={styles.plan}
                  onClick={() => {
                    buriedSdk.buried({
                      event: `Shoplus官网_${width > 1024 ? "Web" : "H5"}`,
                      scene: `For Influencers_View Plans`,
                      URL: process.env.publicApiDomain,
                    });
                  }}
                >
                  {t('View Plans')}
                </a>
              </div>
            </div>
          </div>

          <div className=" animate-box">
            <div className={`${styles.itemCardWrap} ant`}>
              <div className={`${styles["i-left"]} `}>
                <div className={`${styles["i-left-item"]} `}>
                  <span className={styles.sup}>{t('Influencers')}</span>
                  <span>152.5M</span>
                </div>
                <div className={`${styles["i-left-item"]} `}>
                  <span className={styles.sup}>{t('Views')}</span>
                  <span>90.6B</span>
                </div>
              </div>
              <div
                className={`animate-box cm-in-chart-pie ${styles["chart-pie"]}`}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.itemImg}`}>
        <Image
          src={atavar1}
          alt="TikTok influencers marketing platform"
          layout="responsive"
        ></Image>
      </div>
    </div>
  );
};
export default Index;
